
import { Component, Vue } from 'vue-property-decorator'
import $ from 'jquery'
import 'slick-carousel'
import Shuffle from 'shuffle'

@Component({
  components: {
  }
})
export default class ThemeHomeView extends Vue {
  data () {
    return {
      parallaxBox: null,
      c2left: null,
      c2top: null,
      c3left: null,
      c3top: null,
      c4left: null,
      c4top: null,
      c5left: null,
      c5top: null,
      c6left: null,
      c6top: null,
      c7left: null,
      c7top: null,
      c8left: null,
      c8top: null,
      c9left: null,
      c9top: null
    }
  }

  metaInfo () {
    return {
      title: 'blaka',
      meta: [
        { name: 'viewport', content: 'width=device-width, initial-scale=2, maximum-scale=1' }
      ]
    }
  }

  head () {
    return {
    // creates a title tag in header.
      title: {
        inner: 'Titi-'
      },
      meta: [
      // creates a meta description tag in header.
        { name: 'viewport', content: 'width=device-width, initial-scale=2, maximum-scale=1' }
      ]
    }
  }

  created () {
    window.addEventListener('resize', this.setMovingData)
  }

  destroyed () {
    window.removeEventListener('resize', this.setMovingData)
  }

  mounted () {
    $('.navbar-burger').click(function () {
      $('.navbar-burger').toggleClass('is-active')
      $('.navbar-menu').toggleClass('is-active')
    })

    $(window).scroll(function () {
      if ($('.navbar').offset().top > 100) {
        $('.navbar').addClass('nav-bg')
      } else {
        $('.navbar').removeClass('nav-bg')
      }
    })

    // Background-images
    $('[data-background]').each(function () {
      $(this).css({
        'background-image': 'url(' + $(this).data('background') + ')'
      })
    })

    // background color
    $('[data-color]').each(function () {
      $(this).css({
        'background-color': $(this).data('color')
      })
    })

    // progress bar
    $('[data-progress]').each(function () {
      $(this).css({
        bottom: $(this).data('progress')
      })
    })

    $('.testimonial-slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      autoplay: true,
      slidesToScroll: 1,
      arrows: false,
      adaptiveHeight: true
    })

    $('.client-logo-slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      dots: false,
      arrows: false,
      respondTo: 'min',
      variableWidth: false,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    })

    var myShuffle = Shuffle.shuffle(document.querySelector('.shuffle-wrapper'), {
      itemSelector: '.shuffle-item',
      buffer: 1
    })

    $('input[name="shuffle-filter"]').on('change', function (evt) {
      var input = evt.currentTarget
      if (input.checked) {
        myShuffle.filter(input.value)
      }
    })

    $('.filter-menu .button').click(function () {
      $(this).addClass('is-active').siblings().removeClass('is-active')
    })

    this.setMovingData()
    this.parallaxBox = document.getElementById('parallax')
    this.parallaxBox.onmousemove = this.parallaxMouseMove.bind(this)

    var clientSlider = document.getElementsByClassName('client-logo-slider')[0]
    var slickTrack = clientSlider.getElementsByClassName('slick-track')[0]
    slickTrack.style.width = window.innerWidth + 'px'

    $(window).trigger('resize')
    // Window.resizeTo(400, 800)
    // Window.resizeTo(400, 800)
  }

  setMovingData () {
    var obj = document.getElementById('l2')
    var parentObj = obj.parentNode
    var containerWidth = parentObj.offsetWidth
    var containerHeight = parentObj.offsetHeight

    this.c2left = containerWidth * 0.1
    this.c2top = containerHeight * 0.2
    this.c3left = containerWidth * 0.4
    this.c3top = containerHeight * 0.2
    this.c4left = containerWidth * 0.55
    this.c4top = containerHeight * 0.25
    this.c5left = containerWidth * 0.9
    this.c5top = containerHeight * 0.1
    this.c6left = containerWidth * 0.1
    this.c6top = containerHeight * 0.9
    this.c7left = containerWidth * 0.6
    this.c7top = containerHeight * 0.7
    this.c8left = containerWidth * 0.5
    this.c8top = containerHeight * 0.9
    this.c9left = containerWidth * 0.9
    this.c9top = containerHeight * 0.8

    var x = containerWidth / 2
    var y = containerHeight / 2

    this.mouseParallax('l2', this.c2left, this.c2top, x, y, 25)
    this.mouseParallax('l3', this.c3left, this.c3top, x, y, 20)
    this.mouseParallax('l4', this.c4left, this.c4top, x, y, 65)
    this.mouseParallax('l5', this.c5left, this.c5top, x, y, 30)
    this.mouseParallax('l6', this.c6left, this.c6top, x, y, 45)
    this.mouseParallax('l7', this.c7left, this.c7top, x, y, 30)
    this.mouseParallax('l8', this.c8left, this.c8top, x, y, 25)
    this.mouseParallax('l9', this.c9left, this.c9top, x, y, 40)
  }

  parallaxMouseMove (event) {
    event = event || window.event
    var x = event.clientX - this.parallaxBox.offsetLeft
    var y = event.clientY - this.parallaxBox.offsetTop

    this.mouseParallax('l2', this.c2left, this.c2top, x, y, 25)
    this.mouseParallax('l3', this.c3left, this.c3top, x, y, 20)
    this.mouseParallax('l4', this.c4left, this.c4top, x, y, 65)
    this.mouseParallax('l5', this.c5left, this.c5top, x, y, 30)
    this.mouseParallax('l6', this.c6left, this.c6top, x, y, 45)
    this.mouseParallax('l7', this.c7left, this.c7top, x, y, 30)
    this.mouseParallax('l8', this.c8left, this.c8top, x, y, 25)
    this.mouseParallax('l9', this.c9left, this.c9top, x, y, 40)
  }

  mouseParallax (id, left, top, mouseX, mouseY, speed) {
    var obj = document.getElementById(id)
    var parentObj = obj.parentNode
    var containerWidth = parseInt(parentObj.offsetWidth)
    var containerHeight = parseInt(parentObj.offsetHeight)
    obj.style.left = left - (((mouseX - (parseInt(obj.offsetWidth) / 2 + left)) / containerWidth) * speed) + 'px'
    obj.style.top = top - (((mouseY - (parseInt(obj.offsetHeight) / 2 + top)) / containerHeight) * speed) + 'px'
  }
}
